/* eslint-disable react/no-danger */
import React from 'react';
import _ from 'lodash';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from './layouts/BoxedContainer';

function FreeZoneStrategicLocation({ id, data }) {
  const image = _.get(data, 'image', {});
  const mobileImage = _.get(data, 'mobileImage', {});
  const title = _.get(data, 'title', '');
  const text = _.get(data, 'text', '');

  return (
    <section id={id} className="h-auto relative z-0">
      <div className="pt-3 lg:pt-12 absolute left-0 right-0 top-0 z-10">
        <BoxedContainer>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="flex flex-col gap-5 items-center relative z-10">
            <div
              className="child:text-clamp20to40 child:ltr:!font-URWDINMedium 
            child:rtl:!font-GESSTwoDWTCMedium child:leading-[1.3] 
            last:child:!m-0
            child:text-center child:text-[#231F20]"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <div className="py-px bg-red w-10 lg:w-12.5 lg:mb-1.25" />
            <div
              className="child:text-clamp12to18 child:ltr:!font-URWDINRegular 
            child:rtl:!font-GESSTwoDWTCLight child:leading-1.4 
            last:child:!m-0
            child:text-center child:text-[#4D4D4D]"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </motion.div>
        </BoxedContainer>
      </div>
      {_.isEmpty(image) || (
        <LazyLoadImage
          src={image.url}
          alt={title}
          wrapperClassName="relative lg:-mt-20 2xl:-mt-40 3xl:-mt-60 w-full 
          !hidden md:!inline-block"
          className="w-full h-full object-cover
            min-h-[443px] hidden md:block"
        />
      )}
      {_.isEmpty(mobileImage) || (
        <LazyLoadImage
          src={mobileImage.url}
          alt={title}
          wrapperClassName="relative top-4 md:-top-16
            relative w-full"
          className="w-full object-cover block md:hidden"
        />
      )}
    </section>
  );
}

export default FreeZoneStrategicLocation;
